var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgActivityTypeTest({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FAF3DC",
    width: 27.253,
    height: 26.507,
    rx: 10.916
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#EACA61"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.176 6.68c3.86 0 8.087 3.23 8.087 7.511 0 4.282-3.176 8.582-8.087 8.582-4.912 0-8.95-3.405-8.95-8.475s5.09-7.619 8.95-7.619zm.605 2.343c-3.344 0-6.055 2.537-6.055 5.665 0 3.13 2.71 5.666 6.055 5.666 3.345 0 6.056-2.537 6.056-5.666 0-3.128-2.711-5.665-6.056-5.665z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.185 12.406c.163.25-.666 1.174-1.54 2.072-.839.863-1.61 1.631-2.16 1.729-.55.097-1.113-.178-1.447-.63-.349-.47-.352-1.203-.043-1.664.348-.519 1.952-.95 3.273-1.258.98-.228 1.781-.458 1.917-.249zm-5.356-9.144c.686-.57 2.443-.1 2.959.404.515.505.456 1.357-.11 1.717-.564.36-2.355.367-2.852.004-.498-.363-.683-1.554.003-2.125z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityTypeTest);
export default __webpack_public_path__ + "static/media/activity-type-test.a43786e3a8888aa34a516d807f7595f2.svg";
export { ForwardRef as ReactComponent };